import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core/core.module';
import { CoursesComponent } from './courses/courses.component';
import {
  DownloadDocumentationComponent,
  SendDiplomaComponent,
  ChangesAccessComponent
} from './courses/bulk-actions-courses';
import { CoursesRoutingModule } from './courses-routing.module';
import { NoCoursesComponent } from './no-courses/no-courses.component';
import { CourseCardComponent } from './course-card/course-card.component';
import { ItineraryCardComponent } from './course-card/itinerary-card/itinerary-card.component';
import { CoursesService } from '../core/services/courses.service';
import { CourseDetailComponent } from './course-detail/course-detail.component';
import { CoursesListComponent } from './courses-list/courses-list.component';
import { ItineraryPublishModalComponent } from './modals/itinerary-publish-modal/itinerary-publish-modal.component';

@NgModule({
  declarations: [
    CoursesComponent,
    NoCoursesComponent,
    CourseCardComponent,
    CourseDetailComponent,
    CoursesListComponent,
    ItineraryCardComponent,
    ItineraryPublishModalComponent,
    DownloadDocumentationComponent,
    SendDiplomaComponent,
    ChangesAccessComponent
  ],
  imports: [CommonModule, CoreModule, CoursesRoutingModule],
  exports: [CoursesComponent, CoursesListComponent, ItineraryPublishModalComponent],
  providers: [CoursesService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoursesModule {}
